import classnames from 'classnames';
import classes from 'styles/components/Anniversary/Timeline.module.scss';

const TIMELINE = {
  1977: [
    {
      html: '<b>Hyatt Legal Services</b> law firm founded',
      backgroundColor: 'white',
      left: false,
      circle: true,
      outline: true,
    },
  ],
  1981: [
    {
      html: 'First group legal benefit plan implemented',
      backgroundColor: 'white',
      left: true,
      circle: true,
    },
  ],
  1987: [
    {
      html: '<b>First voluntary enrollment</b> legal plan <b>implemented</b>',
      backgroundColor: 'white',
      left: false,
      circle: true,
    },
  ],
  1990: [
    {
      html: 'Hyatt Legal Plans spun off from Hyatt Legal Services',
      backgroundColor: 'white',
      left: true,
      circle: true,
    },
  ],
  1997: [
    {
      html: 'Hyatt Legal Plans acquired by Metlife',
      backgroundColor: 'blue',
      left: false,
      circle: true,
      outline: true,
    },
  ],
  1999: [
    {
      html: '<b>1 million</b> legal plan <b>participants</b>',
      backgroundColor: 'blue',
      left: true,
      circle: true,
    },
  ],
  2002: [
    {
      html: '<b>500</b> group legal plan <b>sponsors</b>',
      backgroundColor: 'blue',
      left: false,
      circle: true,
      image: 'anniversary/icon-persona.png',
    },
  ],
  2006: [
    {
      html: 'MetLife Legal Plans received <b>Standard of Excellence</b> WebAward and wins Call Center Excellence Award',
      backgroundColor: 'blue',
      left: true,
      circle: true,
    },
  ],
  2007: [
    {
      html: '<b>10th anniversary as a MetLife Company,</b> 100 Fortune 500&reg; sponsors, 1,000 sponsors, 4 million participants and 10,000 plan attorneys',
      backgroundColor: 'blue',
      left: false,
      circle: true,
      image: 'anniversary/icon-birthday-cake.png',
      outline: true,
    },
  ],
  2011: [
    {
      html: '<b>138 Fortune 500&reg; sponsors, 1,300 sponsors and 12,000 plan attorneys.</b> MetLife Legals Plans earns three prestigious customer service awards',
      backgroundColor: 'blue',
      left: true,
      circle: true,
      image: 'anniversary/icon-persona.png',
    },
  ],
  2012: [
    {
      html: '<b>More than 150 Fortune 500&reg; sponsors and 12,000 plan attorneys.</b> MetLife Legal Plans celebrates 35 years as a company and 15 years in the MetLife family',
      backgroundColor: 'blue',
      left: false,
      circle: true,
      image: 'anniversary/icon-persona.png',
    },
  ],
  2015: [
    {
      html: '<b>Ingrid Tolentino</b> joins MetLife Legal Plans as <b>CEO</b>',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      positionFromTop: 30,
    },
    {
      html: "MetLife Legal Plans's Client Service Center wins a <b>Gold Stevie&reg; Award</b> in the Best Customer Service category for the third year in a row",
      backgroundColor: 'blue',
      left: false,
      circle: false,
      image: 'anniversary/icon-gold-2015.png',
      positionFromTop: 70,
    },
  ],
  2016: [
    {
      html: '<b>Added Plus Parents option</b> to plans which covers legal assistance for up to eight parents',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      positionFromTop: 30,
    },
    {
      html: 'Introduced <b>LifeStages, Identity Management Services</b>',
      backgroundColor: 'blue',
      left: false,
      circle: false,
      positionFromTop: 60,
    },
  ],
  2017: [
    {
      html: 'Established the <b>Diversity, Equity & Inclusion Council</b>',
      backgroundColor: 'blue',
      left: false,
      circle: false,
      positionFromTop: 40,
    },
    {
      html: '<b>20th anniversary</b> as a MetLife Company, 180 Fortune 500® sponsors, 2,300 sponsors, over 3 million plan participants, and 14,000 plan attorneys',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      image: 'anniversary/icon-birthday-cake.png',
      positionFromTop: 40,
    },
    {
      html: '<b>Launched Disaster Relief Program</b> and Triple Bureau Credit Monitoring',
      backgroundColor: 'blue',
      left: false,
      circle: false,
      positionFromTop: 80,
    },
  ],
  2018: [
    {
      html: '<b>Access to over 1,700 self-help documents</b> for both current and prospective members',
      backgroundColor: 'blue',
      left: false,
      circle: true,
    },
  ],
  2019: [
    {
      html: '<b>Acquired</b> Willing.com, a digital estate planning solution',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      image: 'anniversary/icon-willing.png',
      positionFromTop: 30,
    },
    {
      html: 'Introduced <b>Reproductive Assistance Law coverage</b>',
      backgroundColor: 'blue',
      left: false,
      circle: false,
      positionFromTop: 40,
    },
  ],
  2020: [
    {
      html: '<b>Launched "Healthcare Heroes",</b> supporting healthcare workers during the pandemic with free estate planning',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      positionFromTop: 20,
    },
    {
      html: '<b>New member experience</b> via updated website',
      backgroundColor: 'blue',
      left: false,
      circle: false,
      positionFromTop: 70,
    },
  ],
  2021: [
    {
      html: '<b>Enhanced Digital Estate Planning</b> to include real-time video notary',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      positionFromTop: 30,
    },
    {
      html: '<i>Crain\'s Cleveland</i> names us as <b>"Notable Business Championing Diversity & Inclusion"</b>',
      backgroundColor: 'blue',
      left: false,
      circle: false,
      positionFromTop: 40,
    },
    {
      html: 'MetLife Legal Plans <b>wins its seventh Stevie Award</b>, this time for the website',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      positionFromTop: 70,
    },
  ],
  2022: [
    {
      html: 'Launched <b>caregiving support services</b> with <b>Family First</b>',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      positionFromTop: 20,
    },
    {
      html: '<b>25 years of providing best-in-class legal services as part of MetLife</b>, the leading innovator and recognized leader in protection planning, and retirement and savings solutions worldwide.',
      backgroundColor: 'blue',
      left: false,
      circle: false,
      image: 'anniversary/icon-birthday-cake.png',
      positionFromTop: 20,
    },
    {
      html: '<b>More than 4,000 sponsors including 220+ Fortune 500 companies</b>, over 18,000 plan attorneys, and 5 million covered participants',
      backgroundColor: 'blue',
      left: true,
      circle: false,
      positionFromTop: 80,
    },
  ],
};

const LINE_BACKGROUND_COLORS = ['#a4ce4e', '#38977d', '#0090da', '#0061a0'];

const Timeline = () => (
  <div className={classes.container}>
    <div className={classes.mobileDivider} />

    <div className={classes.metlifeContainer}>
      <img src="anniversary/logo-metlife.png" alt="" />
    </div>

    {Object.keys(TIMELINE).map((year, index) =>
      TIMELINE[year].map(
        ({ html, backgroundColor, left, circle, positionFromTop, outline, image }, eventIndex) => {
          // NOTE: The CSS for this component isn't very organized, it's a mix of inline styles
          //   and imported styles, to follow the design as closely as possible

          const YEAR_LABEL_SPACING = 120;
          const LIGHT_BLUE = '#F6FCFE';
          const yearLabelClass = circle ? classes.circle : classes.rectangle;
          const colorLabelClass = backgroundColor === 'white' ? classes.white : classes.blue;
          const eventAttribute = eventIndex === 0 ? 'top' : 'margin-top';
          const eventOffset =
            eventIndex === 0
              ? positionFromTop - 60
              : YEAR_LABEL_SPACING * (positionFromTop / 100) - YEAR_LABEL_SPACING;
          const circleToRectangleTransitionMargin =
            ['2015', '2019'].includes(year) && eventIndex === 0 ? 60 : 0;

          return (
            <div
              key={year}
              className={classnames(classes.lineWrapper)}
              style={{
                'margin-top': `${
                  eventIndex <= 1
                    ? circleToRectangleTransitionMargin
                    : -YEAR_LABEL_SPACING * eventIndex
                }px`,
                height: `${
                  eventIndex <= 1 ? YEAR_LABEL_SPACING : eventIndex * YEAR_LABEL_SPACING
                }px`,
              }}
            >
              <div className={classes.yearWrapper}>
                {left && (
                  <div
                    className={classes.leftLine}
                    style={{ [eventAttribute]: `${eventOffset}px` }}
                  >
                    <div className={classes.leftEvent}>
                      {image && <img src={image} alt="" />}
                      <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: html }}
                        style={{ 'background-color': Number(year) < 1997 ? 'white' : LIGHT_BLUE }}
                      />
                    </div>
                  </div>
                )}

                {!left && (
                  <div
                    className={classes.rightLine}
                    style={{ [eventAttribute]: `${eventOffset}px` }}
                  >
                    <div className={classes.rightEvent}>
                      {image && <img src={image} alt="" />}
                      <p
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: html }}
                        style={{ 'background-color': Number(year) < 1997 ? 'white' : LIGHT_BLUE }}
                      />
                    </div>
                  </div>
                )}

                {eventIndex === 0 && (
                  <div
                    className={classnames(
                      classes.year,
                      yearLabelClass,
                      colorLabelClass,
                      outline ? classes.outline : '',
                    )}
                  >
                    {['2017', '2022'].includes(year) && <div className={classes.greenTop} />}
                    <div className={classes.border} />
                    <p>
                      <b>{year}</b>
                    </p>
                  </div>
                )}
              </div>

              {eventIndex <= 1 && (
                <div
                  className={classes.line}
                  style={{
                    'background-color':
                      LINE_BACKGROUND_COLORS[
                        Math.floor((index / Object.keys(TIMELINE).length) * 4)
                      ],
                  }}
                >
                  {year === '2022' && eventIndex === 1 && (
                    <div className={classes.downArrow}>&#8227;</div>
                  )}
                </div>
              )}
            </div>
          );
        },
      ),
    )}
  </div>
);

export default Timeline;
